import React, { useState, useEffect, useCallback } from 'react';
import ContentLayout from '../../layout/ContentLayout';
import GenericTable from '../../components/tables/GenericTable';
import Pagination from '../../components/layout/Pagination';
import styles from '../../styles/vips.module.scss';
import Search from 'antd/es/transfer/search';
import { useNavigate } from 'react-router-dom';
import { fetchVips, extendVip } from '../../api/vips-api';
import dayjs from 'dayjs';
import {exportUsers} from "../../api/user-api";
import {toast} from "react-toastify";
import {Button} from "antd";
import Spinner from '../../components/elements/Spinner/Spinner';
import VipValidUntilModal from '../../components/modals/VipValidUntilModal';
import { usePermissions } from '../../context/PermissionsContext';

const Vips = () => {
  const navigate = useNavigate();
  const { can } = usePermissions();
  const [search, setSearch] = useState('');

  const onSearch = (value) => {
    setSearch(value);
  };
  const [viewDetailsId, setViewDetailsId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isExtendVipModalOpen, setIsExtendVipModalOpen] = useState(false);
  const [extendVipUser, setExtendVipUser] = useState(null);
  const [loadingExtendVip, setLoadingExtendVip] = useState(false);

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    {
      key: 'firstLastName',
      label: 'Korisnik',
      render: (val, row) => (
        <>
          {row?.firstName} {row?.lastName}
        </>
      ),
    },
    {
      key: 'phone',
      label: 'Broj telefona',
      render: (val, row) => (
          <>
            {row?.vip?.profile?.phone ?? '-'}
          </>
      ),
    },
    // {
    //   key: 'vip',
    //   label: 'VIP Status',
    //   render: (val, row) => {
    //     return (
    //       <span className={val ? 'active' : 'inactive'}>
    //         {val ? 'Da' : 'Ne'}
    //       </span>
    //     );
    //   },
    // },
    {
      key: 'purchaseDate',
      label: 'Datum kupovine',
      render: (val, row) => {
        console.log('VIP joinedAt date:', row?.vip?.joinedAt);
        const date = dayjs(row?.vip?.joinedAt).format('DD.MM.YYYY.');
        return <span>{date}</span>;
      },
    },
   /* {
      key: 'expiryDate',
      label: 'Datum isteka članstva',
      render: (val, row) => {
        console.log('VIP joinedAt date:', row?.vip?.expiresAt);
        const date = dayjs(row?.vip?.expiresAt).format('DD.MM.YYYY.');
        return <span>{date}</span>;
      },
    },*/
  ];

  const actions = [
    {
      key: 'view-details',
      label: 'Vidi detalje',
      icon: <img src="/assets/icons/view-icon.svg" alt="Vidi detalje" />,
      onClick: (user) => navigate(`/vip/${user._id}`),
    },
    {
      key: 'extend-vip',
      label: 'Produži VIP',
      icon: <img src="/assets/icons/edit-icon.svg" alt="Produži VIP" />,
      onClick: (user) => {
        setExtendVipUser(user);
        setIsExtendVipModalOpen(true);
      },
      disabled: () => !can('users:write'),
    },
  ];

  const getTableData = useCallback(async () => {
    const { data, success, message } = await fetchVips({
      page: currentPage,
      limit: 10,
      // filter: appliedFilters,
      search: debouncedSearch,
    });
    if (success) {
      console.log('Loyalty data fetched:', data);
      setList(data?.users);
      setTotalPages(data?.pagination?.totalPages);
    } else {
      console.log(message || 'Error while fetching the vips.');
    }
    setLoading(false);
  }, [currentPage, debouncedSearch]);

  useEffect(() => {
    getTableData();
  }, [getTableData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    if (search !== debouncedSearch) {
      setCurrentPage(1);
    }

    return () => clearTimeout(timer);
  }, [search]);

  const handleExtendVipModalClose = () => {
    setIsExtendVipModalOpen(false);
    setExtendVipUser(null);
  };

  const handleExtendVip = async (validUntil) => {
    setLoadingExtendVip(true);
    toast.loading('Produžavanje VIP članstva...');
    const userId = extendVipUser._id;
    try {
      const { success, message } = await extendVip(userId, validUntil);

      if (!success) {
        toast.dismiss();
        toast.error(message || 'Greška pri produžavanju VIP članstva');
        return;
      }

      setIsExtendVipModalOpen(false);
      setExtendVipUser(null);
      toast.dismiss();
      toast.success('VIP članstvo je uspešno produženo');
      getTableData();
    } finally {
      setLoadingExtendVip(false);
    }
  };

  const handleExport = async () => {
    const result = await exportUsers({
      search: debouncedSearch,
      vipStatus: 'active',
    });

    if (!result.success) {
      toast.error(result.message);
    } else if (result.data === null) {
      toast.info(result.message);
    } else {
      toast.success('Korisnici uspešno izvezeni');
    }
  };
  
  console.log('list of vips:', list);

  return (
    <>
      <ContentLayout pt={true}>
        <div className={styles.vips}>
          <div className={styles.header}>
            <p className="title">VIP članovi</p>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Search
                placeholder={'Pretraži'}
                className="search-input"
                allowClear
                enterButton
                // onSearch={(value) => onSearch(value)}
                onChange={(e) => onSearch(e.target.value)}
                width="auto"
              />
              <Button
                  className={`btn-tertiary`}
                  onClick={handleExport}
                  icon={
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                      <path d="M8 12L3 7h3V1h4v6h3L8 12z"/>
                      <path d="M1 14h14v2H1z"/>
                    </svg>
                  }
              >
                Izvezi
              </Button>
            </div>
          </div>
          <div className={`${styles.body} vips_wrapper`}>
            {loading ? (
              <Spinner size="lg" />
            ) : (
              <>
                <GenericTable
                  data={list}
                  columns={columns}
                  actions={actions}
                />
                {list?.length > 0 && (
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={onPageChange}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </ContentLayout>
      <VipValidUntilModal
        mode="extend"
        isOpen={isExtendVipModalOpen}
        onClose={handleExtendVipModalClose}
        onConfirm={handleExtendVip}
        loading={loadingExtendVip}
        userName={
          extendVipUser
            ? `${extendVipUser.firstName} ${extendVipUser.lastName}`
            : ''
        }
        currentValidUntil={extendVipUser?.vip?.validUntil}
      />
    </>
  );
};
export default Vips;
